export const DeliveryIcon = ({ color = "#0F2C52" }: { color?: string }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1481_3373)">
        <path
          d="M6.36075 6.63672C6.24753 6.81636 6.18747 7.02438 6.1875 7.23672V11.7367"
          stroke={color}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.4375 12.8625V9.63745"
          stroke={color}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.1875 11.7375V7.23755H3.9375C3.04239 7.23755 2.18395 7.59313 1.55101 8.22606C0.918079 8.859 0.5625 9.71744 0.5625 10.6125V15.1125C0.5625 15.4109 0.681026 15.6971 0.892005 15.908C1.10298 16.119 1.38913 16.2375 1.6875 16.2375H2.25"
          stroke={color}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.5625 11.7375H6.1875"
          stroke={color}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.9375 15.675C3.9375 16.1226 4.11529 16.5518 4.43176 16.8683C4.74822 17.1848 5.17745 17.3625 5.625 17.3625C6.07255 17.3625 6.50178 17.1848 6.81824 16.8683C7.13471 16.5518 7.3125 16.1226 7.3125 15.675C7.3125 15.2275 7.13471 14.7983 6.81824 14.4818C6.50178 14.1653 6.07255 13.9875 5.625 13.9875C5.17745 13.9875 4.74822 14.1653 4.43176 14.4818C4.11529 14.7983 3.9375 15.2275 3.9375 15.675Z"
          stroke={color}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.9375 15.675C12.9375 16.1226 13.1153 16.5518 13.4318 16.8683C13.7482 17.1848 14.1774 17.3625 14.625 17.3625C15.0726 17.3625 15.5018 17.1848 15.8182 16.8683C16.1347 16.5518 16.3125 16.1226 16.3125 15.675C16.3125 15.2275 16.1347 14.7983 15.8182 14.4818C15.5018 14.1653 15.0726 13.9875 14.625 13.9875C14.1774 13.9875 13.7482 14.1653 13.4318 14.4818C13.1153 14.7983 12.9375 15.2275 12.9375 15.675Z"
          stroke={color}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 16.2375H11.25"
          stroke={color}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.23486 5.13745C8.23486 6.33093 8.70897 7.47552 9.55288 8.31943C10.3968 9.16335 11.5414 9.63745 12.7349 9.63745C13.9283 9.63745 15.0729 9.16335 15.9168 8.31943C16.7608 7.47552 17.2349 6.33093 17.2349 5.13745C17.2349 3.94398 16.7608 2.79938 15.9168 1.95547C15.0729 1.11156 13.9283 0.637451 12.7349 0.637451C11.5414 0.637451 10.3968 1.11156 9.55288 1.95547C8.70897 2.79938 8.23486 3.94398 8.23486 5.13745Z"
          stroke={color}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.7349 2.88745V7.38745"
          stroke={color}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.4849 5.13745H14.9849"
          stroke={color}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1481_3373">
          <rect width="18" height="18" fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};
